<template>
  <div class="container">
    <div class="content-wrapper">
      <div class="cities-header">
        <button type="button" class="back-button" @click="goBack">
          <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
            <path
                d="M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path>
          </svg>
          <span>返回首页</span>
        </button>
        <div class="page-header">
          <h2 class="cities-title">
            <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
              <path
                  d="M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"></path>
            </svg>
            选择服务城市
          </h2>
          <p class="page-subtitle">请选择您所在的城市，我们将为您提供本地化服务</p>
        </div>
      </div>

      <!-- 搜索框 -->
      <div class="search-section">
        <div class="search-input-wrapper">
          <span class="search-prefix">
            <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
              <path
                  d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path>
            </svg>
          </span>
          <input
              v-model="searchKeyword"
              type="search"
              class="search-input"
              placeholder="搜索城市名称..."
              @input="handleSearch"
          />
          <button type="button" class="search-button" @click="handleSearch">
            <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
              <path
                  d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- 城市列表 -->
      <div class="cities-grid">
        <div
            v-for="region in filteredRegions"
            :key="region.name"
            class="card province-card"
        >
          <div class="card-body">
            <h4 class="province-title">{{ region.name }}</h4>
            <div class="divider"></div>
            <div class="cities-list">
              <button
                  v-for="city in region.cities"
                  :key="city"
                  type="button"
                  class="city-button"
                  @click="selectCity(city)"
              >
                {{ city }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  background: #f5f6fa;
}

.content-wrapper {
  margin: auto;
  width: 100%;
  width: 75rem;
  padding: 1.5rem;
}

.cities-header {
  margin-bottom: 2rem;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  background: none;
  border: none;
  color: #1890ff;
  cursor: pointer;
  font-size: 0.875rem;
  transition: color 0.3s;
  margin-bottom: 1rem;
}

.back-button:hover {
  color: #40a9ff;
}

.back-button svg {
  width: 1em;
  height: 1em;
}

.page-header {
  text-align: center;
}

.cities-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #333;
}

.cities-title svg {
  color: #1890ff;
}

.page-subtitle {
  font-size: 0.875rem;
  color: #666;
  margin: 0;
}

/* 搜索框 */
.search-section {
  margin-bottom: 2rem;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 31.25rem;
  margin: 0 auto;
}

.search-prefix {
  position: absolute;
  left: 1rem;
  color: #ff9800;
  z-index: 1;
  display: flex;
  align-items: center;
}

.search-input {
  flex: 1;
  padding: 0.75rem 3.5rem 0.75rem 2.5rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #333;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px 0 0 6px;
  outline: none;
  transition: all 0.3s;
}

.search-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.search-input::placeholder {
  color: #bfbfbf;
}

.search-button {
  padding: 0.75rem 1rem;
  background: #1890ff;
  color: #fff;
  border: 1px solid #1890ff;
  border-left: none;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.search-button:hover {
  background: #40a9ff;
  border-color: #40a9ff;
}

.search-button svg {
  width: 1em;
  height: 1em;
}

/* 城市网格 */
.cities-grid {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.province-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-body {
  padding: 1.5rem;
}

.province-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: #333;
}

.divider {
  height: 1px;
  background: #e8e8e8;
  margin-bottom: 1rem;
}

.cities-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 0.5rem;
}

.city-button {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  color: #333;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
}

.city-button:hover {
  border-color: #1890ff;
  color: #1890ff;
  background: #e6f7ff;
}

.city-button:active {
  transform: scale(0.98);
}

</style>

<script setup>
import {ref, computed} from 'vue'
import {useRouter} from 'vue-router'

const router = useRouter()
const searchKeyword = ref('')

// 城市数据
const regions = ref([
  {
    name: '华北地区',
    cities: ['北京', '天津', '石家庄', '太原', '呼和浩特', '唐山', '秦皇岛', '邯郸', '邢台', '保定', '张家口', '承德', '沧州', '廊坊', '衡水', '大同', '阳泉', '长治', '晋城', '朔州', '晋中', '运城', '忻州', '临汾', '吕梁', '包头', '乌海', '赤峰', '通辽', '鄂尔多斯', '呼伦贝尔', '巴彦淖尔', '乌兰察布']
  },
  {
    name: '华东地区',
    cities: ['上海', '南京', '杭州', '合肥', '福州', '南昌', '济南', '苏州', '无锡', '常州', '南通', '扬州', '镇江', '泰州', '盐城', '淮安', '宿迁', '连云港', '徐州', '宁波', '温州', '嘉兴', '湖州', '绍兴', '金华', '衢州', '舟山', '台州', '丽水', '芜湖', '蚌埠', '淮南', '马鞍山', '淮北', '铜陵', '安庆', '黄山', '滁州', '阜阳', '宿州', '六安', '亳州', '池州', '宣城', '厦门', '莆田', '三明', '泉州', '漳州', '南平', '龙岩', '宁德', '南昌', '景德镇', '萍乡', '九江', '新余', '鹰潭', '赣州', '吉安', '宜春', '抚州', '上饶', '青岛', '淄博', '枣庄', '东营', '烟台', '潍坊', '济宁', '泰安', '威海', '日照', '临沂', '德州', '聊城', '滨州', '菏泽']
  },
  {
    name: '华南地区',
    cities: ['广州', '深圳', '珠海', '汕头', '佛山', '韶关', '湛江', '肇庆', '江门', '茂名', '惠州', '梅州', '汕尾', '河源', '阳江', '清远', '东莞', '中山', '潮州', '揭阳', '云浮', '南宁', '柳州', '桂林', '梧州', '北海', '防城港', '钦州', '贵港', '玉林', '百色', '贺州', '河池', '来宾', '崇左', '海口', '三亚', '三沙', '儋州', '五指山', '琼海', '文昌', '万宁', '东方', '定安', '屯昌', '澄迈', '临高', '白沙', '昌江', '乐东', '陵水', '保亭', '琼中']
  },
  {
    name: '华中地区',
    cities: ['郑州', '开封', '洛阳', '平顶山', '安阳', '鹤壁', '新乡', '焦作', '濮阳', '许昌', '漯河', '三门峡', '南阳', '商丘', '信阳', '周口', '驻马店', '济源', '武汉', '黄石', '十堰', '宜昌', '襄阳', '鄂州', '荆门', '孝感', '荆州', '黄冈', '咸宁', '随州', '恩施', '仙桃', '潜江', '天门', '神农架', '长沙', '株洲', '湘潭', '衡阳', '邵阳', '岳阳', '常德', '张家界', '益阳', '郴州', '永州', '怀化', '娄底', '湘西']
  },
  {
    name: '西南地区',
    cities: ['重庆', '成都', '自贡', '攀枝花', '泸州', '德阳', '绵阳', '广元', '遂宁', '内江', '乐山', '南充', '眉山', '宜宾', '广安', '达州', '雅安', '巴中', '资阳', '阿坝', '甘孜', '凉山', '贵阳', '六盘水', '遵义', '安顺', '毕节', '铜仁', '黔西南', '黔东南', '黔南', '昆明', '曲靖', '玉溪', '保山', '昭通', '丽江', '普洱', '临沧', '楚雄', '红河', '文山', '西双版纳', '大理', '德宏', '怒江', '迪庆', '拉萨', '昌都', '山南', '日喀则', '那曲', '阿里', '林芝']
  },
  {
    name: '西北地区',
    cities: ['西安', '铜川', '宝鸡', '咸阳', '渭南', '延安', '汉中', '榆林', '安康', '商洛', '兰州', '嘉峪关', '金昌', '白银', '天水', '武威', '张掖', '平凉', '酒泉', '庆阳', '定西', '陇南', '临夏', '甘南', '西宁', '海东', '海北', '黄南', '海南', '果洛', '玉树', '海西', '银川', '石嘴山', '吴忠', '固原', '中卫', '乌鲁木齐', '克拉玛依', '吐鲁番', '哈密', '昌吉', '博尔塔拉', '巴音郭楞', '阿克苏', '克孜勒苏', '喀什', '和田', '伊犁', '塔城', '阿勒泰']
  },
  {
    name: '东北地区',
    cities: ['沈阳', '大连', '鞍山', '抚顺', '本溪', '丹东', '锦州', '营口', '阜新', '辽阳', '盘锦', '铁岭', '朝阳', '葫芦岛', '长春', '吉林', '四平', '辽源', '通化', '白山', '松原', '白城', '延边', '哈尔滨', '齐齐哈尔', '鸡西', '鹤岗', '双鸭山', '大庆', '伊春', '佳木斯', '七台河', '牡丹江', '黑河', '绥化', '大兴安岭']
  }
])

// 过滤后的地区
const filteredRegions = computed(function() {
  if (!searchKeyword.value.trim()) {
    return regions.value
  }

  const keyword = searchKeyword.value.trim().toLowerCase()
  return regions.value
      .map(function(region) {
        return {
          ...region,
          cities: region.cities.filter(function(city) { return city.toLowerCase().includes(keyword) })
        }
      })
      .filter(function(region) { return region.cities.length > 0 })
})

// 搜索处理
function handleSearch() {
  // 搜索逻辑已在 computed 中实现
}

// 选择城市
function selectCity(city) {
  console.log('选择城市:', city)
  // 这里可以保存城市信息到 store 或 localStorage
  // 然后跳转回首页或其他页面
  router.push('/')
}

// 返回首页
function goBack() {
  router.push('/')
}
</script>
